export default __webpack_public_path__ + "static/media/pessoa.ebd4e437.svg";